import * as firebase from 'firebase'
export default {
  // wrapper actions to kick off all fetches for the tools module
  fetchTools ({dispatch}) {
    dispatch('fetchForms')
  },
  /**
   * Retrieves forms from database
   */
  fetchForms ({commit}) {
    commit('setLoading', true, {root: true})
    firebase.database().ref('/tools/forms').once('value')
      .then((response) => {
        commit('setLoading', false, {root: true})
        commit('updateForms', response.val())
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  },
  /**
   * Submits a new form to database
   */
  newForm ({commit, dispatch}, payload) {
    commit('setLoading', true, {root: true})
    // push blank value into forms to generate a key
    firebase.database().ref('/tools/forms').push(false)
      .then((response) => {
        // put the actual form data at the location of key
        const form = {
          ...payload,
          id: response.key
        }
        firebase.database().ref('/tools/forms/' + form.id).update(form)
        // update local state
        commit('updateForms', { [form.id]: form })
        commit('setLoading', false, {root: true})
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  },
  /**
   * Updates an existing form in database
   */
  updateForm ({commit, dispatch}, payload) {
    const form = payload
    commit('setLoading', true, {root: true})
    firebase.database().ref('/tools/forms/' + form.id).update(form)
      .then((response) => {
        commit('setLoading', false, {root: true})
        // update local state
        commit('updateForms', { [form.id]: form })
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  },
  /**
   * Removes a form from the database
   */
  deleteForm ({commit}, id) {
    commit('setLoading', true, {root: true})
    firebase.database().ref('/tools/forms/' + id).remove()
      .then((response) => {
        commit('setLoading', false, {root: true})
        // remove from local state
        commit('deleteForm', id)
      })
      .catch((error) => {
        commit('setLoading', false, {root: true})
        commit('setError', error, {root: true})
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tools/forms/actions.js